<template>
  <div class="cases">
    <section class="cases-hero">
      <div class="cases-hero-bg">
        <img src="/static/jdal.png" alt="典型案例">
        <!-- <div class="cases-hero-overlay"></div> -->
      </div>
     <!-- <div class="cases-hero-content">
        <h1 class="fade-in-up">典型案例</h1>
        <p class="hero-subtitle fade-in-up delay-1">CLASSIC CASES</p>
      </div> -->
    </section>

    <section class="cases-filter-section">
      <div class="container">
        <div class="filter-nav" data-aos="fade-up">
          <div
            v-for="cat in categories"
            :key="cat.id"
            role="button"
            tabindex="0"
            :class="['filter-nav-item', { active: activeCategory === cat.id }]"
            @click="handleNavClick(cat.id)"
            @keydown.enter="handleNavClick(cat.id)"
          >
            {{ cat.name }}
          </div>
        </div>
      </div>
    </section>

    <section class="cases-list-section">
      <div class="container">
        <div v-if="pagedCases.length > 0" class="cases-grid">
          <router-link
            v-for="(caseItem, index) in pagedCases"
            :key="caseItem.id"
            :to="`/cases/detail/${caseItem.id}`"
            class="case-card"
            data-aos="fade-up"
            :data-aos-delay="(index % 3) * 120"
          >
            <div class="case-card-image">
              <img :src="caseItem.image" :alt="caseItem.name" data-aos="zoom-in">
              <div class="case-card-overlay">
                <span class="case-card-category">{{ caseItem.category }}</span>
              </div>
            </div>
            <div class="case-card-content">
              <h3 class="case-card-title">{{ caseItem.name }}</h3>
            </div>
          </router-link>
        </div>

        <div v-else class="cases-empty">
          <i class="el-icon-document-delete"></i>
          <p>暂无相关案例</p>
        </div>

        <div class="cases-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[9, 18, 27, 36]"
            :page-size="pageSize"
            :total="filteredCases.length"
            layout="total, sizes, prev, pager, next, jumper"
            background
          ></el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mockCases } from '@/api/mock'

export default {
  name: 'Cases',
  data() {
    return {
      casesList: mockCases,
      categories: [
        { id: 'all', name: '典型案例' },
        { id: 'sanitation', name: '环卫工程' },
        { id: 'brand', name: '品牌建设' },
        { id: 'desert', name: '石漠化工' },
        { id: 'investment', name: '投资运营' },
        { id: 'agriculture', name: '农林土地' },
        { id: 'smart', name: '数智案例' },
        { id: 'solid', name: '固废治理' }
      ],
      activeCategory: 'all',
      currentPage: 1,
      pageSize: 9
    }
  },
  computed: {
    filteredCases() {
      if (this.activeCategory === 'all') {
        return this.casesList
      }

      const categoryMap = {
        sanitation: '环卫工程',
        brand: '品牌建设',
        desert: '石漠化工',
        investment: '投资运营',
        agriculture: '农林土地',
        smart: '数智案例',
        solid: '固废治理'
      }

      return this.casesList.filter(c => c.category === categoryMap[this.activeCategory])
    },
    pagedCases() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredCases.slice(start, start + this.pageSize)
    }
  },
  mounted() {
    this.syncFromQuery()
  },
  watch: {
    '$route.query.cat'() {
      this.syncFromQuery()
    }
  },
  methods: {
    syncFromQuery() {
      const cat = this.$route.query.cat
      if (cat && this.categories.find(c => c.id === cat)) {
        this.activeCategory = cat
        this.currentPage = 1
      }
    },
    handleNavClick(id) {
      this.activeCategory = id
      this.currentPage = 1
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
    }
  }
}
</script>

<style lang="scss" scoped>
.cases-hero {
  position: relative;
  height: 420px;
  overflow: hidden;
}

.cases-hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.cases-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.85) 0%, rgba(26, 86, 219, 0.7) 100%);
}

.cases-hero-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 8%;
}

.cases-hero-content h1 {
  font-size: 52px;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
  letter-spacing: 4px;
}

.hero-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 6px;
  font-weight: 300;
}

.cases-filter-section {
  background: white;
  border-bottom: 1px solid #e8ecf1;
}

.filter-nav {
  display: flex;
  align-items: center;
}

.filter-nav-item {
  position: relative;
  padding: 22px 28px;
  font-size: 16px;
  color: #64748b;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.3s ease;
  user-select: none;
  line-height: 1;

  &:hover {
    color: #1a56db;
  }

  &.active {
    color: #1a56db;
    font-weight: 600;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 3px;
      background: #1a56db;
    }
  }
}

.cases-list-section {
  padding: 50px 0 60px;
  background: #f7f9fc;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.case-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  text-decoration: none;
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    transform: translateY(-6px);

    .case-card-image img {
      transform: scale(1.08);
      filter: grayscale(0%);
    }

    .case-card-content h3 {
      color: #1a56db;
    }
  }

  &:not(:hover) .case-card-image img {
    filter: grayscale(60%);
  }

  &:nth-child(-n+3) .case-card-image img {
    filter: grayscale(0%);
  }

  &:hover .case-card-image img {
    filter: grayscale(0%) !important;
  }
}

.case-card-image {
  position: relative;
  height: 220px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.5s ease;
  }

  .case-card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, transparent 40%, rgba(0, 0, 0, 0.5) 100%);
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 16px;
  }

  .case-card-category {
    padding: 4px 14px;
    background: #1a56db;
    color: white;
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;
  }
}

.case-card-content {
  padding: 20px;

  h3 {
    font-size: 17px;
    font-weight: 600;
    color: #1e293b;
    line-height: 1.5;
    transition: color 0.3s ease;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.cases-empty {
  text-align: center;
  padding: 80px 20px;
  color: #94a3b8;
  background: white;
  border-radius: 8px;

  i {
    font-size: 60px;
    margin-bottom: 20px;
  }

  p {
    font-size: 16px;
  }
}

.cases-pagination {
  margin-top: 40px;
  text-align: center;
}

@media (max-width: 992px) {
  .cases-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .case-card {
    &:not(:hover) .case-card-image img {
      filter: grayscale(0%);
    }
  }

  .cases-hero-content {
    padding: 0 40px;
  }

  .cases-hero-content h1 {
    font-size: 40px;
  }

  .filter-nav-item {
    padding: 18px 20px;
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .cases-hero {
    height: 320px;
  }

  .cases-grid {
    grid-template-columns: 1fr;
  }

  .cases-hero-content {
    padding: 0 24px;
    align-items: center;
    text-align: center;
  }

  .cases-hero-content h1 {
    font-size: 32px;
    letter-spacing: 2px;
  }

  .hero-subtitle {
    font-size: 14px;
    letter-spacing: 4px;
  }

  .filter-nav {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .filter-nav-item {
    padding: 16px 18px;
    font-size: 14px;
    white-space: nowrap;
  }

  .cases-list-section {
    padding: 30px 0 40px;
  }

  .case-card-image {
    height: 200px;
  }

  .case-card-content h3 {
    font-size: 15px;
  }
}
</style>